export default {"src":"/_next/static/media/ar.556bd347.svg","height":26,"width":32,"blurWidth":0,"blurHeight":0};